import { render } from "./ContentActivityLog.vue?vue&type=template&id=0a491c56"
import script from "./ContentActivityLog.vue?vue&type=script&lang=js"
export * from "./ContentActivityLog.vue?vue&type=script&lang=js"
script.render = render

export default script